import { Platform } from '@pelckmans/business-components/components/lti-modal';

export default function usePlatformName(): Platform {
  const { REACT_APP_P_STUDIO_GROUP } = process.env;

  switch (REACT_APP_P_STUDIO_GROUP) {
    case 'BAO':
      return 'Pelckmans Basisonderwijs';
    case 'ES':
      return 'Pelckmans Portail';
    case 'SO':
      return 'Pelckmans Portaal';
    case 'VO':
      return 'Pelckmans NT2';
    default:
      throw new Error('invalid studio group configured as environment variable "REACT_APP_P_STUDIO_GROUP"');
  }
}
